export default __webpack_public_path__ + "static/media/recomienda-amigos.e685fc4b.png";